import { RelationalTableDataset } from './../../dataset/relational-table.dataset';
import { Metamodel } from 'app/model/base/model';
import { ODataResourceDataset } from 'app/model/dataset/odata-resource.dataset';
import { TabularCopySource } from './tabular-type.copysource';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.relationalTable.copySourceType,
    display: [],
    tags: {
        datasetModel: [
            Metamodel.modelFor(RelationalTableDataset),
            Metamodel.modelFor(ODataResourceDataset)
        ]
    }
})
export class RelationalCopySource extends TabularCopySource {
}
